export default function initShowPassword() {
  document.querySelectorAll('.show-password').forEach(btn => {
    const input = btn.parentNode.querySelector('input')

    btn.addEventListener('click', (e)=>{
      e.preventDefault();

      btn.classList.toggle('active')

      if(input.getAttribute('type') == 'password'){
        input.setAttribute('type', 'text')
      } else {
        input.setAttribute('type', 'password')
      }
    });
  })
}
